
import { defineComponent, computed, SetupContext } from 'vue'
import useStore from './store'

const store = useStore(window.pinia)

export default defineComponent({
    setup (props: SetupContext['attrs'], { attrs }) {
        store.fetchList(attrs.compositionIds as string[])

        return {
            compositions: computed(() => store.getList()),
        }
    },
})
